import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=b9e2a90a&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_register.scss?vue&type=style&index=0&id=b9e2a90a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e2a90a",
  null
  
)

export default component.exports